var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _g2, _path16, _path17, _path18, _path19, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 209,
    viewBox: "0 0 335 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.258 166.22C213.067 166.22 250.205 129.083 250.205 83.1102C250.205 37.1378 212.903 0 167.258 0C121.449 0 84.3115 37.1378 84.3115 83.1102C84.3115 129.083 121.449 166.22 167.258 166.22Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.358 136.734C259.063 136.734 262.066 133.731 262.066 130.026C262.066 126.322 259.063 123.318 255.358 123.318C251.654 123.318 248.65 126.322 248.65 130.026C248.65 133.731 251.654 136.734 255.358 136.734Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M265.174 110.557C267.704 110.557 269.755 108.506 269.755 105.976C269.755 103.446 267.704 101.396 265.174 101.396C262.644 101.396 260.593 103.446 260.593 105.976C260.593 108.506 262.644 110.557 265.174 110.557Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7283 28.4664C91.2583 28.4664 93.3092 26.4155 93.3092 23.8856C93.3092 21.3556 91.2583 19.3047 88.7283 19.3047C86.1984 19.3047 84.1475 21.3556 84.1475 23.8856C84.1475 26.4155 86.1984 28.4664 88.7283 28.4664Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7525 116.813C65.4509 116.813 69.2598 113.004 69.2598 108.305C69.2598 103.607 65.4509 99.7979 60.7525 99.7979C56.054 99.7979 52.2451 103.607 52.2451 108.305C52.2451 113.004 56.054 116.813 60.7525 116.813Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M229.119 85.0713L233.54 83.7387C233.86 83.6457 233.86 83.1809 233.54 83.0879L229.119 81.7553C229.005 81.7243 228.923 81.6417 228.892 81.5281L227.559 77.1171C227.466 76.7969 227.001 76.7969 226.908 77.1171L225.576 81.5281C225.545 81.6417 225.462 81.7243 225.348 81.7553L220.937 83.0879C220.617 83.1809 220.617 83.6457 220.937 83.7387L225.359 85.0713C225.472 85.1023 225.555 85.1849 225.586 85.2986L226.919 89.7198C227.012 90.0401 227.476 90.0401 227.569 89.7198L228.902 85.2986C228.923 85.1849 229.005 85.1023 229.119 85.0713Z",
    fill: "#ADB6C8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M202.943 37.6285L207.364 36.296C207.685 36.203 207.685 35.7382 207.364 35.6452L202.943 34.3127C202.829 34.2817 202.747 34.1991 202.716 34.0855L201.383 29.6747C201.29 29.3545 200.825 29.3545 200.732 29.6747L199.4 34.0855C199.369 34.1991 199.286 34.2817 199.173 34.3127L194.762 35.6452C194.441 35.7382 194.441 36.203 194.762 36.296L199.183 37.6285C199.297 37.6595 199.379 37.7421 199.41 37.8558L200.743 42.2768C200.836 42.597 201.301 42.597 201.394 42.2768L202.726 37.8558C202.747 37.7421 202.829 37.6595 202.943 37.6285Z",
    fill: "#ADB6C8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.449 43.1482L140.318 41.9822C140.598 41.9009 140.598 41.4941 140.318 41.4128L136.449 40.2469C136.35 40.2197 136.277 40.1474 136.25 40.048L135.084 36.1887C135.003 35.9085 134.596 35.9085 134.515 36.1887L133.349 40.048C133.322 40.1474 133.249 40.2197 133.15 40.2469L129.29 41.4128C129.01 41.4941 129.01 41.9009 129.29 41.9822L133.159 43.1482C133.258 43.1753 133.331 43.2476 133.358 43.347L134.524 47.2154C134.605 47.4956 135.012 47.4956 135.093 47.2154L136.259 43.347C136.277 43.2476 136.35 43.1753 136.449 43.1482Z",
    fill: "#ADB6C8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.636 114.199L112.505 112.867C112.785 112.774 112.785 112.309 112.505 112.216L108.636 110.883C108.537 110.852 108.465 110.77 108.438 110.656L107.272 106.245C107.19 105.925 106.784 105.925 106.702 106.245L105.536 110.656C105.509 110.77 105.437 110.852 105.337 110.883L101.478 112.216C101.198 112.309 101.198 112.774 101.478 112.867L105.346 114.199C105.446 114.23 105.518 114.313 105.545 114.426L106.711 118.848C106.793 119.168 107.199 119.168 107.281 118.848L108.447 114.426C108.465 114.313 108.537 114.23 108.636 114.199Z",
    fill: "#ADB6C8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.442 63.8134L105.206 62.9806C105.406 62.9225 105.406 62.632 105.206 62.5739L102.442 61.7411C102.371 61.7218 102.32 61.6701 102.3 61.5991L101.467 58.8425C101.409 58.6424 101.119 58.6424 101.061 58.8425L100.228 61.5991C100.208 61.6701 100.157 61.7218 100.086 61.7411L97.3288 62.5739C97.1287 62.632 97.1287 62.9225 97.3288 62.9806L100.092 63.8134C100.163 63.8328 100.215 63.8845 100.234 63.9555L101.067 66.7185C101.125 66.9187 101.416 66.9187 101.474 66.7185L102.307 63.9555C102.32 63.8845 102.371 63.8328 102.442 63.8134Z",
    fill: "#ADB6C8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.89 91.1455L134.654 90.3127C134.854 90.2546 134.854 89.9641 134.654 89.906L131.89 89.0732C131.819 89.0538 131.768 89.0021 131.748 88.9311L130.916 86.1745C130.857 85.9744 130.567 85.9744 130.509 86.1745L129.676 88.9311C129.657 89.0021 129.605 89.0538 129.534 89.0732L126.777 89.906C126.577 89.9641 126.577 90.2546 126.777 90.3127L129.54 91.1455C129.611 91.1648 129.663 91.2165 129.682 91.2875L130.515 94.0506C130.573 94.2507 130.864 94.2507 130.922 94.0506L131.755 91.2875C131.768 91.2165 131.819 91.1648 131.89 91.1455Z",
    fill: "#ADB6C8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M155.321 13.2832L158.084 12.4504C158.285 12.3923 158.285 12.1018 158.084 12.0437L155.321 11.2109C155.25 11.1915 155.198 11.1398 155.179 11.0688L154.346 8.31221C154.288 8.11208 153.998 8.11208 153.939 8.31221L153.107 11.0688C153.087 11.1398 153.036 11.1915 152.965 11.2109L150.208 12.0437C150.008 12.1018 150.008 12.3923 150.208 12.4504L152.971 13.2832C153.042 13.3025 153.094 13.3542 153.113 13.4252L153.946 16.1883C154.004 16.3884 154.295 16.3884 154.353 16.1883L155.186 13.4252C155.198 13.3542 155.25 13.3025 155.321 13.2832Z",
    fill: "#ADB6C8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M220.8 131.652L223.563 130.82C223.763 130.761 223.763 130.471 223.563 130.413L220.8 129.58C220.729 129.561 220.677 129.509 220.658 129.438L219.825 126.681C219.767 126.481 219.476 126.481 219.418 126.681L218.585 129.438C218.566 129.509 218.514 129.561 218.443 129.58L215.686 130.413C215.486 130.471 215.486 130.761 215.686 130.82L218.45 131.652C218.521 131.672 218.572 131.723 218.592 131.794L219.424 134.557C219.483 134.758 219.773 134.758 219.831 134.557L220.664 131.794C220.677 131.723 220.729 131.672 220.8 131.652Z",
    fill: "#ADB6C8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M142.824 95.79C135.867 100.859 126.723 108.214 126.723 114.675C126.723 118.459 126.723 123.845 126.723 127.659C126.723 129.2 128.93 130.131 130.203 129.264C133.56 126.98 139.363 124.348 147.695 125.111C161.809 126.403 145.21 102.748 145.21 102.748L142.824 95.79Z",
    fill: "url(#paint0_linear_611_129506)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M193.415 95.79C200.373 100.959 209.517 108.214 209.517 114.675C209.517 118.459 209.517 123.845 209.517 127.659C209.517 129.2 207.31 130.131 206.037 129.264C202.68 126.98 196.877 124.348 188.545 125.111C174.431 126.403 191.03 102.748 191.03 102.748L193.415 95.79Z",
    fill: "url(#paint1_linear_611_129506)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_611_129506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.071 24.624C154.951 33.967 139.247 56.927 142.129 86.1488C144.912 115.371 147.397 129.783 152.764 133.262C158.231 136.74 163.598 137.535 168.071 137.535C172.544 137.535 177.911 136.74 183.378 133.262C188.844 129.783 191.23 115.371 194.013 86.1488C196.796 56.927 181.091 33.967 168.071 24.624Z",
    fill: "url(#paint2_linear_611_129506)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_611_129506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.009 141.61H158.131C156.54 141.61 155.348 140.318 155.348 138.827V133.957H180.892V138.728C180.792 140.318 179.5 141.61 178.009 141.61Z",
    fill: "url(#paint3_linear_611_129506)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M169.463 94.2002H166.68V130.877H169.463V94.2002Z",
    fill: "url(#paint4_linear_611_129506)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M168.07 74.222C173.505 74.222 177.91 69.8165 177.91 64.382C177.91 58.9475 173.505 54.542 168.07 54.542C162.636 54.542 158.23 58.9475 158.23 64.382C158.23 69.8165 162.636 74.222 168.07 74.222Z",
    stroke: "#9FA8BA",
    strokeWidth: 6.54411,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M181.687 160.595C181.687 168.645 175.226 208.999 167.176 208.999C159.125 208.999 152.664 168.645 152.664 160.595C152.664 152.544 159.125 146.083 167.176 146.083C175.226 146.083 181.687 152.643 181.687 160.595Z",
    fill: "#EAEEF9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M167.176 190.413C164.294 184.25 161.014 167.154 161.014 161.688C161.014 158.308 163.797 155.525 167.176 155.525C170.555 155.525 173.339 158.308 173.339 161.688C173.339 167.154 170.059 184.151 167.176 190.413Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_611_129506",
    x: 105.791,
    y: 6.62772,
    width: 124.539,
    height: 184.896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.9963
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.9963
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_611_129506"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_611_129506",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_611_129506",
    x: 119.355,
    y: 115.961,
    width: 97.5292,
    height: 79.6385,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.9963
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.9963
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_611_129506"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_611_129506",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_611_129506",
    x1: 140.055,
    y1: 97.0572,
    x2: 140.055,
    y2: 117.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_611_129506",
    x1: 196.189,
    y1: 97.0572,
    x2: 196.189,
    y2: 117.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_611_129506",
    x1: 168.043,
    y1: 22.0123,
    x2: 168.043,
    y2: 138.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_611_129506",
    x1: 168.111,
    y1: 133.78,
    x2: 168.111,
    y2: 141.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_611_129506",
    x1: 168.071,
    y1: 95.4743,
    x2: 168.071,
    y2: 116.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.597a727ec9b23a1a41e10edffebbf51b.svg";
export { ForwardRef as ReactComponent };